<template>
  <router-view />
</template>

<script>
export default {
  name: 'MainLayout'
}
</script>

